import Config from '../../AppConfig';
import { get } from './core/fetch';

export const getInvestmentOptions = async (
	adviserUUID: string
): Promise<any> => {
	return await get(
		`${Config.mlcApiPrefix}/advisers/${adviserUUID}/customers?search=investmentOptions`,
		{
			withAuth: true,
			noGateway: false,
		}
	);
};
